import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';
import flatten from 'lodash/flatten';
import Editor from './Editor';

var AsyncEditor =
/*#__PURE__*/
function (_Component) {
  _inherits(AsyncEditor, _Component);

  function AsyncEditor(props) {
    var _this;

    _classCallCheck(this, AsyncEditor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AsyncEditor).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onEditorRef", function (editor) {
      _this.editor = editor;

      _this.props.onEditorRef(editor);
    });

    _this.editor = React.lazy(function () {
      return props.plugins.then(function (plugins) {
        return {
          "default": function _default(props) {
            return React.createElement(Editor, Object.assign({}, _this.props, {
              plugins: flatten(plugins)
            }));
          }
        };
      });
    });
    return _this;
  }

  _createClass(AsyncEditor, [{
    key: "render",
    value: function render() {
      var Component = this.editor;
      return React.createElement(Suspense, {
        fallback: null
      }, React.createElement(Component, Object.assign({
        onEditorRef: this.onEditorRef
      }, this.props)));
    }
  }]);

  return AsyncEditor;
}(Component);

_defineProperty(AsyncEditor, "propTypes", {
  plugins: PropTypes.shape({
    then: PropTypes.func,
    "catch": PropTypes.func
  }),
  onEditorRef: PropTypes.func
});

_defineProperty(AsyncEditor, "defaultProps", {
  onEditorRef: function onEditorRef() {}
});

export { AsyncEditor as default };